import axios from 'axios'
import userStore from '../store/modules/userStore'

const axiosInstance = axios.create({
  baseURL: typeof window !== 'undefined' ? window.env.VUE_APP_ROOT_API : 'default_value'
})

axiosInstance.interceptors.request.use((config) => {
  config.headers['Authorization'] = userStore.state.token || ''
  config.headers['idToken'] = userStore.state.idToken || ''
  return config
}, (error) => {
  return Promise.reject(error)
})

// Example to simulate API delay:
// axiosInstance.interceptors.response.use(
//   async (response) => {
//     if (response.config.url.includes('/helicopters')) {
//       // Simulate a 5-second network delay
//       await new Promise(resolve => setTimeout(resolve, 5000));
//     }
//     return response;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

export default {
  get: axiosInstance.get,
  post: axiosInstance.post,
  put: axiosInstance.put,
  delete: axiosInstance.delete
}
